import { DatabaseCode, toDatabaseCode } from "./database-code";

export type SystemProcessType = DatabaseCode;

const integration: SystemProcessType = {
  code: "INTEGRATION",
  displayValue: {
    id: "common.entity.systemprocesstype.integration",
    defaultMessage: "Integration",
  },
};

const batch: SystemProcessType = {
  code: "BATCH",
  displayValue: {
    id: "common.entity.systemprocesstype.batch",
    defaultMessage: "Batch",
  },
};

const report: SystemProcessType = {
  code: "REPORT",
  displayValue: {
    id: "common.entity.systemprocesstype.report",
    defaultMessage: "Report",
  },
};

const maintenance: SystemProcessType = {
  code: "MAINTENANCE",
  displayValue: {
    id: "common.entity.systemprocesstype.maintenance",
    defaultMessage: "Maintenance",
  },
};

const notification: SystemProcessType = {
  code: "NOTIFICATION",
  displayValue: {
    id: "common.entity.systemprocesstype.notification",
    defaultMessage: "Notification",
  },
};

export const systemProcessType = {
  integration,
  batch,
  report,
  maintenance,
  notification,
};

export const systemProcessTypes = Object.values(systemProcessType);

export const toSystemProcessType = (code: string): SystemProcessType =>
  toDatabaseCode(code, systemProcessTypes);

export const toSystemProcessTypeSafely = (
  code: string | undefined
): SystemProcessType | undefined =>
  code ? toDatabaseCode(code, systemProcessTypes) : undefined;
